import { ValidationError } from '../../shared/errors/BaseErrors';

const TELEGRAM_PREFIX = 'https://t.me/';
const PRIVATE_PATH_PREFIXES = ['+', 'joinchat/', 'c/'];

const normalize = (raw: string): string => {
  let s = (raw ?? '').trim();
  if (!s) return '';
  s = s.replace(/^@/, '').replace(/^https:\/\//, '').replace(/^http:\/\//, '').replace(/^www\./, '').replace(/\/$/, '');
  if (!s) return '';
  if (!s.includes('/')) s = `t.me/${s}`;
  s = s.replace('t.me/s/', 't.me/');
  return `https://${s}`;
};

const isPrivateNormalized = (normalized: string): boolean => {
  const path = normalized.startsWith(TELEGRAM_PREFIX) ? normalized.slice(TELEGRAM_PREFIX.length) : normalized;
  return PRIVATE_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
};

export class ChannelLink {
  private readonly value: string;
  private constructor(value: string) { this.value = value; }
  static create(raw: string): ChannelLink {
    const normalized = normalize(raw);
    if (!normalized) throw new ValidationError('channel-link-required');
    return new ChannelLink(normalized);
  }
  static isPrivate(raw: string): boolean {
    return isPrivateNormalized(normalize(raw));
  }
  get Value(): string { return this.value; }
  get isPrivate(): boolean { return isPrivateNormalized(this.value); }
}
